"use strict";
exports.__esModule = true;
var tabs = function () {
    var tabContainer = document.querySelector('.tabs-container');
    var tabButtons = Array.from(document.querySelectorAll('.tabs li'));
    var handleEvents = function () {
        tabButtons.forEach(function (tab, index) {
            tab.addEventListener('click', function () {
                var newAttribute = (index + 1).toString();
                tabContainer.setAttribute('data-tabbed', newAttribute);
            });
        });
    };
    var init = function () {
        handleEvents();
    };
    init();
};
exports["default"] = tabs;
